/*
import WaveSurfer from "https://unpkg.com/wavesurfer.js@7/dist/wavesurfer.esm.js";
import RegionsPlugin from "https://unpkg.com/wavesurfer.js@7/dist/plugins/regions.esm.js";
*/ var $c03aca78159de43e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/** Decode an array buffer into an audio buffer */ function $c03aca78159de43e$var$decode(audioData, sampleRate) {
    return $c03aca78159de43e$var$__awaiter(this, void 0, void 0, function*() {
        const audioCtx = new AudioContext({
            sampleRate: sampleRate
        });
        const decode = audioCtx.decodeAudioData(audioData);
        return decode.finally(()=>audioCtx.close());
    });
}
/** Normalize peaks to -1..1 */ function $c03aca78159de43e$var$normalize(channelData) {
    const firstChannel = channelData[0];
    if (firstChannel.some((n)=>n > 1 || n < -1)) {
        const length = firstChannel.length;
        let max = 0;
        for(let i = 0; i < length; i++){
            const absN = Math.abs(firstChannel[i]);
            if (absN > max) max = absN;
        }
        for (const channel of channelData)for(let i = 0; i < length; i++)channel[i] /= max;
    }
    return channelData;
}
/** Create an audio buffer from pre-decoded audio data */ function $c03aca78159de43e$var$createBuffer(channelData, duration) {
    // If a single array of numbers is passed, make it an array of arrays
    if (typeof channelData[0] === "number") channelData = [
        channelData
    ];
    // Normalize to -1..1
    $c03aca78159de43e$var$normalize(channelData);
    return {
        duration: duration,
        length: channelData[0].length,
        sampleRate: channelData[0].length / duration,
        numberOfChannels: channelData.length,
        getChannelData: (i)=>channelData === null || channelData === void 0 ? void 0 : channelData[i],
        copyFromChannel: AudioBuffer.prototype.copyFromChannel,
        copyToChannel: AudioBuffer.prototype.copyToChannel
    };
}
const $c03aca78159de43e$var$Decoder = {
    decode: $c03aca78159de43e$var$decode,
    createBuffer: $c03aca78159de43e$var$createBuffer
};
var $c03aca78159de43e$export$2e2bcd8739ae039 = $c03aca78159de43e$var$Decoder;


var $064d4de22181c65c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $064d4de22181c65c$var$watchProgress(response, progressCallback) {
    return $064d4de22181c65c$var$__awaiter(this, void 0, void 0, function*() {
        if (!response.body || !response.headers) return;
        const reader = response.body.getReader();
        const contentLength = Number(response.headers.get("Content-Length")) || 0;
        let receivedLength = 0;
        // Process the data
        const processChunk = (value)=>$064d4de22181c65c$var$__awaiter(this, void 0, void 0, function*() {
                // Add to the received length
                receivedLength += (value === null || value === void 0 ? void 0 : value.length) || 0;
                const percentage = Math.round(receivedLength / contentLength * 100);
                progressCallback(percentage);
            });
        const read = ()=>$064d4de22181c65c$var$__awaiter(this, void 0, void 0, function*() {
                let data;
                try {
                    data = yield reader.read();
                } catch (_a) {
                    // Ignore errors because we can only handle the main response
                    return;
                }
                // Continue reading data until done
                if (!data.done) {
                    processChunk(data.value);
                    yield read();
                }
            });
        read();
    });
}
function $064d4de22181c65c$var$fetchBlob(url, progressCallback, requestInit) {
    return $064d4de22181c65c$var$__awaiter(this, void 0, void 0, function*() {
        // Fetch the resource
        const response = yield fetch(url, requestInit);
        if (response.status >= 400) throw new Error(`Failed to fetch ${url}: ${response.status} (${response.statusText})`);
        // Read the data to track progress
        $064d4de22181c65c$var$watchProgress(response.clone(), progressCallback);
        return response.blob();
    });
}
const $064d4de22181c65c$var$Fetcher = {
    fetchBlob: $064d4de22181c65c$var$fetchBlob
};
var $064d4de22181c65c$export$2e2bcd8739ae039 = $064d4de22181c65c$var$Fetcher;


/** A simple event emitter that can be used to listen to and emit events. */ class $41fb24c6822f7f68$var$EventEmitter {
    constructor(){
        this.listeners = {};
    }
    /** Subscribe to an event. Returns an unsubscribe function. */ on(event, listener, options) {
        if (!this.listeners[event]) this.listeners[event] = new Set();
        this.listeners[event].add(listener);
        if (options === null || options === void 0 ? void 0 : options.once) {
            const unsubscribeOnce = ()=>{
                this.un(event, unsubscribeOnce);
                this.un(event, listener);
            };
            this.on(event, unsubscribeOnce);
            return unsubscribeOnce;
        }
        return ()=>this.un(event, listener);
    }
    /** Unsubscribe from an event */ un(event, listener) {
        var _a;
        (_a = this.listeners[event]) === null || _a === void 0 || _a.delete(listener);
    }
    /** Subscribe to an event only once */ once(event, listener) {
        return this.on(event, listener, {
            once: true
        });
    }
    /** Clear all events */ unAll() {
        this.listeners = {};
    }
    /** Emit an event */ emit(eventName, ...args) {
        if (this.listeners[eventName]) this.listeners[eventName].forEach((listener)=>listener(...args));
    }
}
var $41fb24c6822f7f68$export$2e2bcd8739ae039 = $41fb24c6822f7f68$var$EventEmitter;


class $33a4d7ed38deb55a$var$Player extends (0, $41fb24c6822f7f68$export$2e2bcd8739ae039) {
    constructor(options){
        super();
        this.isExternalMedia = false;
        if (options.media) {
            this.media = options.media;
            this.isExternalMedia = true;
        } else this.media = document.createElement("audio");
        // Controls
        if (options.mediaControls) this.media.controls = true;
        // Autoplay
        if (options.autoplay) this.media.autoplay = true;
        // Speed
        if (options.playbackRate != null) this.onceMediaEvent("canplay", ()=>{
            if (options.playbackRate != null) this.media.playbackRate = options.playbackRate;
        });
    }
    onMediaEvent(event, callback, options) {
        this.media.addEventListener(event, callback, options);
        return ()=>this.media.removeEventListener(event, callback);
    }
    onceMediaEvent(event, callback) {
        return this.onMediaEvent(event, callback, {
            once: true
        });
    }
    getSrc() {
        return this.media.currentSrc || this.media.src || "";
    }
    revokeSrc() {
        const src = this.getSrc();
        if (src.startsWith("blob:")) URL.revokeObjectURL(src);
    }
    canPlayType(type) {
        return this.media.canPlayType(type) !== "";
    }
    setSrc(url, blob) {
        const src = this.getSrc();
        if (src === url) return;
        this.revokeSrc();
        const newSrc = blob instanceof Blob && this.canPlayType(blob.type) ? URL.createObjectURL(blob) : url;
        this.media.src = newSrc;
    }
    destroy() {
        this.media.pause();
        if (this.isExternalMedia) return;
        this.media.remove();
        this.revokeSrc();
        this.media.src = "";
        // Load resets the media element to its initial state
        this.media.load();
    }
    setMediaElement(element) {
        this.media = element;
    }
    /** Start playing the audio */ play() {
        return this.media.play();
    }
    /** Pause the audio */ pause() {
        this.media.pause();
    }
    /** Check if the audio is playing */ isPlaying() {
        return !this.media.paused && !this.media.ended;
    }
    /** Jumpt to a specific time in the audio (in seconds) */ setTime(time) {
        this.media.currentTime = time;
    }
    /** Get the duration of the audio in seconds */ getDuration() {
        return this.media.duration;
    }
    /** Get the current audio position in seconds */ getCurrentTime() {
        return this.media.currentTime;
    }
    /** Get the audio volume */ getVolume() {
        return this.media.volume;
    }
    /** Set the audio volume */ setVolume(volume) {
        this.media.volume = volume;
    }
    /** Get the audio muted state */ getMuted() {
        return this.media.muted;
    }
    /** Mute or unmute the audio */ setMuted(muted) {
        this.media.muted = muted;
    }
    /** Get the playback speed */ getPlaybackRate() {
        return this.media.playbackRate;
    }
    /** Set the playback speed, pass an optional false to NOT preserve the pitch */ setPlaybackRate(rate, preservePitch) {
        // preservePitch is true by default in most browsers
        if (preservePitch != null) this.media.preservesPitch = preservePitch;
        this.media.playbackRate = rate;
    }
    /** Get the HTML media element */ getMediaElement() {
        return this.media;
    }
    /** Set a sink id to change the audio output device */ setSinkId(sinkId) {
        // See https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/setSinkId
        const media = this.media;
        return media.setSinkId(sinkId);
    }
}
var $33a4d7ed38deb55a$export$2e2bcd8739ae039 = $33a4d7ed38deb55a$var$Player;


function $8198ccc12399532a$export$ddfd007dd16e7e72(element, onDrag, onStart, onEnd, threshold = 3, mouseButton = 0) {
    if (!element) return ()=>void 0;
    let unsubscribeDocument = ()=>void 0;
    const onPointerDown = (event)=>{
        if (event.button !== mouseButton) return;
        event.preventDefault();
        event.stopPropagation();
        let startX = event.clientX;
        let startY = event.clientY;
        let isDragging = false;
        const onPointerMove = (event)=>{
            event.preventDefault();
            event.stopPropagation();
            const x = event.clientX;
            const y = event.clientY;
            const dx = x - startX;
            const dy = y - startY;
            if (isDragging || Math.abs(dx) > threshold || Math.abs(dy) > threshold) {
                const rect = element.getBoundingClientRect();
                const { left: left, top: top } = rect;
                if (!isDragging) {
                    onStart === null || onStart === void 0 || onStart(startX - left, startY - top);
                    isDragging = true;
                }
                onDrag(dx, dy, x - left, y - top);
                startX = x;
                startY = y;
            }
        };
        const onPointerUp = ()=>{
            if (isDragging) onEnd === null || onEnd === void 0 || onEnd();
            unsubscribeDocument();
        };
        const onPointerLeave = (e)=>{
            // Listen to events only on the document and not on inner elements
            if (!e.relatedTarget || e.relatedTarget === document.documentElement) onPointerUp();
        };
        const onClick = (event)=>{
            if (isDragging) {
                event.stopPropagation();
                event.preventDefault();
            }
        };
        const onTouchMove = (event)=>{
            if (isDragging) event.preventDefault();
        };
        document.addEventListener("pointermove", onPointerMove);
        document.addEventListener("pointerup", onPointerUp);
        document.addEventListener("pointerout", onPointerLeave);
        document.addEventListener("pointercancel", onPointerLeave);
        document.addEventListener("touchmove", onTouchMove, {
            passive: false
        });
        document.addEventListener("click", onClick, {
            capture: true
        });
        unsubscribeDocument = ()=>{
            document.removeEventListener("pointermove", onPointerMove);
            document.removeEventListener("pointerup", onPointerUp);
            document.removeEventListener("pointerout", onPointerLeave);
            document.removeEventListener("pointercancel", onPointerLeave);
            document.removeEventListener("touchmove", onTouchMove);
            setTimeout(()=>{
                document.removeEventListener("click", onClick, {
                    capture: true
                });
            }, 10);
        };
    };
    element.addEventListener("pointerdown", onPointerDown);
    return ()=>{
        unsubscribeDocument();
        element.removeEventListener("pointerdown", onPointerDown);
    };
}



var $9dbf784afb0c7be3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $9dbf784afb0c7be3$var$Renderer extends (0, $41fb24c6822f7f68$export$2e2bcd8739ae039) {
    constructor(options, audioElement){
        super();
        this.timeouts = [];
        this.isScrollable = false;
        this.audioData = null;
        this.resizeObserver = null;
        this.lastContainerWidth = 0;
        this.isDragging = false;
        this.options = options;
        const parent = this.parentFromOptionsContainer(options.container);
        this.parent = parent;
        const [div, shadow] = this.initHtml();
        parent.appendChild(div);
        this.container = div;
        this.scrollContainer = shadow.querySelector(".scroll");
        this.wrapper = shadow.querySelector(".wrapper");
        this.canvasWrapper = shadow.querySelector(".canvases");
        this.progressWrapper = shadow.querySelector(".progress");
        this.cursor = shadow.querySelector(".cursor");
        if (audioElement) shadow.appendChild(audioElement);
        this.initEvents();
    }
    parentFromOptionsContainer(container) {
        let parent;
        if (typeof container === "string") parent = document.querySelector(container);
        else if (container instanceof HTMLElement) parent = container;
        if (!parent) throw new Error("Container not found");
        return parent;
    }
    initEvents() {
        const getClickPosition = (e)=>{
            const rect = this.wrapper.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientX - rect.left;
            const relativeX = x / rect.width;
            const relativeY = y / rect.height;
            return [
                relativeX,
                relativeY
            ];
        };
        // Add a click listener
        this.wrapper.addEventListener("click", (e)=>{
            const [x, y] = getClickPosition(e);
            this.emit("click", x, y);
        });
        // Add a double click listener
        this.wrapper.addEventListener("dblclick", (e)=>{
            const [x, y] = getClickPosition(e);
            this.emit("dblclick", x, y);
        });
        // Drag
        if (this.options.dragToSeek) this.initDrag();
        // Add a scroll listener
        this.scrollContainer.addEventListener("scroll", ()=>{
            const { scrollLeft: scrollLeft, scrollWidth: scrollWidth, clientWidth: clientWidth } = this.scrollContainer;
            const startX = scrollLeft / scrollWidth;
            const endX = (scrollLeft + clientWidth) / scrollWidth;
            this.emit("scroll", startX, endX);
        });
        // Re-render the waveform on container resize
        const delay = this.createDelay(100);
        this.resizeObserver = new ResizeObserver(()=>{
            delay(()=>this.onContainerResize());
        });
        this.resizeObserver.observe(this.scrollContainer);
    }
    onContainerResize() {
        const width = this.parent.clientWidth;
        if (width === this.lastContainerWidth && this.options.height !== "auto") return;
        this.lastContainerWidth = width;
        this.reRender();
    }
    initDrag() {
        (0, $8198ccc12399532a$export$ddfd007dd16e7e72)(this.wrapper, // On drag
        (_, __, x)=>{
            this.emit("drag", Math.max(0, Math.min(1, x / this.wrapper.getBoundingClientRect().width)));
        }, // On start drag
        ()=>this.isDragging = true, // On end drag
        ()=>this.isDragging = false);
    }
    getHeight(optionsHeight) {
        const defaultHeight = 128;
        if (optionsHeight == null) return defaultHeight;
        if (!isNaN(Number(optionsHeight))) return Number(optionsHeight);
        if (optionsHeight === "auto") return this.parent.clientHeight || defaultHeight;
        return defaultHeight;
    }
    initHtml() {
        const div = document.createElement("div");
        const shadow = div.attachShadow({
            mode: "open"
        });
        shadow.innerHTML = `
      <style>
        :host {
          user-select: none;
          min-width: 1px;
        }
        :host audio {
          display: block;
          width: 100%;
        }
        :host .scroll {
          overflow-x: auto;
          overflow-y: hidden;
          width: 100%;
          position: relative;
        }
        :host .noScrollbar {
          scrollbar-color: transparent;
          scrollbar-width: none;
        }
        :host .noScrollbar::-webkit-scrollbar {
          display: none;
          -webkit-appearance: none;
        }
        :host .wrapper {
          position: relative;
          overflow: visible;
          z-index: 2;
        }
        :host .canvases {
          min-height: ${this.getHeight(this.options.height)}px;
        }
        :host .canvases > div {
          position: relative;
        }
        :host canvas {
          display: block;
          position: absolute;
          top: 0;
          image-rendering: pixelated;
        }
        :host .progress {
          pointer-events: none;
          position: absolute;
          z-index: 2;
          top: 0;
          left: 0;
          width: 0;
          height: 100%;
          overflow: hidden;
        }
        :host .progress > div {
          position: relative;
        }
        :host .cursor {
          pointer-events: none;
          position: absolute;
          z-index: 5;
          top: 0;
          left: 0;
          height: 100%;
          border-radius: 2px;
        }
      </style>

      <div class="scroll" part="scroll">
        <div class="wrapper" part="wrapper">
          <div class="canvases"></div>
          <div class="progress" part="progress"></div>
          <div class="cursor" part="cursor"></div>
        </div>
      </div>
    `;
        return [
            div,
            shadow
        ];
    }
    /** Wavesurfer itself calls this method. Do not call it manually. */ setOptions(options) {
        if (this.options.container !== options.container) {
            const newParent = this.parentFromOptionsContainer(options.container);
            newParent.appendChild(this.container);
            this.parent = newParent;
        }
        if (options.dragToSeek && !this.options.dragToSeek) this.initDrag();
        this.options = options;
        // Re-render the waveform
        this.reRender();
    }
    getWrapper() {
        return this.wrapper;
    }
    getScroll() {
        return this.scrollContainer.scrollLeft;
    }
    destroy() {
        var _a;
        this.container.remove();
        (_a = this.resizeObserver) === null || _a === void 0 || _a.disconnect();
    }
    createDelay(delayMs = 10) {
        const context = {};
        this.timeouts.push(context);
        return (callback)=>{
            context.timeout && clearTimeout(context.timeout);
            context.timeout = setTimeout(callback, delayMs);
        };
    }
    // Convert array of color values to linear gradient
    convertColorValues(color) {
        if (!Array.isArray(color)) return color || "";
        if (color.length < 2) return color[0] || "";
        const canvasElement = document.createElement("canvas");
        const ctx = canvasElement.getContext("2d");
        const gradientHeight = canvasElement.height * (window.devicePixelRatio || 1);
        const gradient = ctx.createLinearGradient(0, 0, 0, gradientHeight);
        const colorStopPercentage = 1 / (color.length - 1);
        color.forEach((color, index)=>{
            const offset = index * colorStopPercentage;
            gradient.addColorStop(offset, color);
        });
        return gradient;
    }
    renderBarWaveform(channelData, options, ctx, vScale) {
        const topChannel = channelData[0];
        const bottomChannel = channelData[1] || channelData[0];
        const length = topChannel.length;
        const { width: width, height: height } = ctx.canvas;
        const halfHeight = height / 2;
        const pixelRatio = window.devicePixelRatio || 1;
        const barWidth = options.barWidth ? options.barWidth * pixelRatio : 1;
        const barGap = options.barGap ? options.barGap * pixelRatio : options.barWidth ? barWidth / 2 : 0;
        const barRadius = options.barRadius || 0;
        const barIndexScale = width / (barWidth + barGap) / length;
        const rectFn = barRadius && "roundRect" in ctx ? "roundRect" : "rect";
        ctx.beginPath();
        let prevX = 0;
        let maxTop = 0;
        let maxBottom = 0;
        for(let i = 0; i <= length; i++){
            const x = Math.round(i * barIndexScale);
            if (x > prevX) {
                const topBarHeight = Math.round(maxTop * halfHeight * vScale);
                const bottomBarHeight = Math.round(maxBottom * halfHeight * vScale);
                const barHeight = topBarHeight + bottomBarHeight || 1;
                // Vertical alignment
                let y = halfHeight - topBarHeight;
                if (options.barAlign === "top") y = 0;
                else if (options.barAlign === "bottom") y = height - barHeight;
                ctx[rectFn](prevX * (barWidth + barGap), y, barWidth, barHeight, barRadius);
                prevX = x;
                maxTop = 0;
                maxBottom = 0;
            }
            const magnitudeTop = Math.abs(topChannel[i] || 0);
            const magnitudeBottom = Math.abs(bottomChannel[i] || 0);
            if (magnitudeTop > maxTop) maxTop = magnitudeTop;
            if (magnitudeBottom > maxBottom) maxBottom = magnitudeBottom;
        }
        ctx.fill();
        ctx.closePath();
    }
    renderLineWaveform(channelData, _options, ctx, vScale) {
        const drawChannel = (index)=>{
            const channel = channelData[index] || channelData[0];
            const length = channel.length;
            const { height: height } = ctx.canvas;
            const halfHeight = height / 2;
            const hScale = ctx.canvas.width / length;
            ctx.moveTo(0, halfHeight);
            let prevX = 0;
            let max = 0;
            for(let i = 0; i <= length; i++){
                const x = Math.round(i * hScale);
                if (x > prevX) {
                    const h = Math.round(max * halfHeight * vScale) || 1;
                    const y = halfHeight + h * (index === 0 ? -1 : 1);
                    ctx.lineTo(prevX, y);
                    prevX = x;
                    max = 0;
                }
                const value = Math.abs(channel[i] || 0);
                if (value > max) max = value;
            }
            ctx.lineTo(prevX, halfHeight);
        };
        ctx.beginPath();
        drawChannel(0);
        drawChannel(1);
        ctx.fill();
        ctx.closePath();
    }
    renderWaveform(channelData, options, ctx) {
        ctx.fillStyle = this.convertColorValues(options.waveColor);
        // Custom rendering function
        if (options.renderFunction) {
            options.renderFunction(channelData, ctx);
            return;
        }
        // Vertical scaling
        let vScale = options.barHeight || 1;
        if (options.normalize) {
            const max = Array.from(channelData[0]).reduce((max, value)=>Math.max(max, Math.abs(value)), 0);
            vScale = max ? 1 / max : 1;
        }
        // Render waveform as bars
        if (options.barWidth || options.barGap || options.barAlign) {
            this.renderBarWaveform(channelData, options, ctx, vScale);
            return;
        }
        // Render waveform as a polyline
        this.renderLineWaveform(channelData, options, ctx, vScale);
    }
    renderSingleCanvas(channelData, options, width, height, start, end, canvasContainer, progressContainer) {
        const pixelRatio = window.devicePixelRatio || 1;
        const canvas = document.createElement("canvas");
        const length = channelData[0].length;
        canvas.width = Math.round(width * (end - start) / length);
        canvas.height = height * pixelRatio;
        canvas.style.width = `${Math.floor(canvas.width / pixelRatio)}px`;
        canvas.style.height = `${height}px`;
        canvas.style.left = `${Math.floor(start * width / pixelRatio / length)}px`;
        canvasContainer.appendChild(canvas);
        const ctx = canvas.getContext("2d");
        this.renderWaveform(channelData.map((channel)=>channel.slice(start, end)), options, ctx);
        // Draw a progress canvas
        if (canvas.width > 0 && canvas.height > 0) {
            const progressCanvas = canvas.cloneNode();
            const progressCtx = progressCanvas.getContext("2d");
            progressCtx.drawImage(canvas, 0, 0);
            // Set the composition method to draw only where the waveform is drawn
            progressCtx.globalCompositeOperation = "source-in";
            progressCtx.fillStyle = this.convertColorValues(options.progressColor);
            // This rectangle acts as a mask thanks to the composition method
            progressCtx.fillRect(0, 0, canvas.width, canvas.height);
            progressContainer.appendChild(progressCanvas);
        }
    }
    renderChannel(channelData, options, width, done) {
        // A container for canvases
        const canvasContainer = document.createElement("div");
        const height = this.getHeight(options.height);
        canvasContainer.style.height = `${height}px`;
        this.canvasWrapper.style.minHeight = `${height}px`;
        this.canvasWrapper.appendChild(canvasContainer);
        // A container for progress canvases
        const progressContainer = canvasContainer.cloneNode();
        this.progressWrapper.appendChild(progressContainer);
        // Determine the currently visible part of the waveform
        const { scrollLeft: scrollLeft, scrollWidth: scrollWidth, clientWidth: clientWidth } = this.scrollContainer;
        const len = channelData[0].length;
        const scale = len / scrollWidth;
        let viewportWidth = Math.min($9dbf784afb0c7be3$var$Renderer.MAX_CANVAS_WIDTH, clientWidth);
        // Adjust width to avoid gaps between canvases when using bars
        if (options.barWidth || options.barGap) {
            const barWidth = options.barWidth || 0.5;
            const barGap = options.barGap || barWidth / 2;
            const totalBarWidth = barWidth + barGap;
            if (viewportWidth % totalBarWidth !== 0) viewportWidth = Math.floor(viewportWidth / totalBarWidth) * totalBarWidth;
        }
        const start = Math.floor(Math.abs(scrollLeft) * scale);
        const end = Math.floor(start + viewportWidth * scale);
        const viewportLen = end - start;
        // Draw a portion of the waveform from start peak to end peak
        const draw = (start, end)=>{
            this.renderSingleCanvas(channelData, options, width, height, Math.max(0, start), Math.min(end, len), canvasContainer, progressContainer);
        };
        const status = {
            head: false,
            tail: end >= len
        };
        const complete = (type)=>{
            status[type] = true;
            if (status.head && status.tail) done();
        };
        // Draw the waveform in viewport chunks, each with a delay
        const headDelay = this.createDelay();
        const tailDelay = this.createDelay();
        const renderHead = (fromIndex, toIndex)=>{
            draw(fromIndex, toIndex);
            if (fromIndex > 0) headDelay(()=>{
                renderHead(fromIndex - viewportLen, toIndex - viewportLen);
            });
            else complete("head");
        };
        const renderTail = (fromIndex, toIndex)=>{
            draw(fromIndex, toIndex);
            if (toIndex < len) tailDelay(()=>{
                renderTail(fromIndex + viewportLen, toIndex + viewportLen);
            });
            else complete("tail");
        };
        renderHead(start, end);
        if (end < len) renderTail(end, end + viewportLen);
    }
    render(audioData) {
        // Clear previous timeouts
        this.timeouts.forEach((context)=>context.timeout && clearTimeout(context.timeout));
        this.timeouts = [];
        // Clear the canvases
        this.canvasWrapper.innerHTML = "";
        this.progressWrapper.innerHTML = "";
        // Width
        if (this.options.width != null) this.scrollContainer.style.width = typeof this.options.width === "number" ? `${this.options.width}px` : this.options.width;
        // Determine the width of the waveform
        const pixelRatio = window.devicePixelRatio || 1;
        const parentWidth = this.scrollContainer.clientWidth;
        const scrollWidth = Math.ceil(audioData.duration * (this.options.minPxPerSec || 0));
        // Whether the container should scroll
        this.isScrollable = scrollWidth > parentWidth;
        const useParentWidth = this.options.fillParent && !this.isScrollable;
        // Width of the waveform in pixels
        const width = (useParentWidth ? parentWidth : scrollWidth) * pixelRatio;
        // Set the width of the wrapper
        this.wrapper.style.width = useParentWidth ? "100%" : `${scrollWidth}px`;
        // Set additional styles
        this.scrollContainer.style.overflowX = this.isScrollable ? "auto" : "hidden";
        this.scrollContainer.classList.toggle("noScrollbar", !!this.options.hideScrollbar);
        this.cursor.style.backgroundColor = `${this.options.cursorColor || this.options.progressColor}`;
        this.cursor.style.width = `${this.options.cursorWidth}px`;
        // Render the waveform
        if (this.options.splitChannels) {
            let counter = 0;
            const done = ()=>{
                counter++;
                if (counter === audioData.numberOfChannels) this.emit("rendered");
            };
            // Render a waveform for each channel
            for(let i = 0; i < audioData.numberOfChannels; i++){
                const options = Object.assign(Object.assign({}, this.options), this.options.splitChannels[i]);
                this.renderChannel([
                    audioData.getChannelData(i)
                ], options, width, done);
            }
        } else {
            // Render a single waveform for the first two channels (left and right)
            const channels = [
                audioData.getChannelData(0)
            ];
            if (audioData.numberOfChannels > 1) channels.push(audioData.getChannelData(1));
            this.renderChannel(channels, this.options, width, ()=>this.emit("rendered"));
        }
        this.audioData = audioData;
        this.emit("render");
    }
    reRender() {
        // Return if the waveform has not been rendered yet
        if (!this.audioData) return;
        // Remember the current cursor position
        const { scrollWidth: scrollWidth } = this.scrollContainer;
        const oldCursorPosition = this.progressWrapper.clientWidth;
        // Re-render the waveform
        this.render(this.audioData);
        // Adjust the scroll position so that the cursor stays in the same place
        if (this.isScrollable && scrollWidth !== this.scrollContainer.scrollWidth) {
            const newCursorPosition = this.progressWrapper.clientWidth;
            this.scrollContainer.scrollLeft += newCursorPosition - oldCursorPosition;
        }
    }
    zoom(minPxPerSec) {
        this.options.minPxPerSec = minPxPerSec;
        this.reRender();
    }
    scrollIntoView(progress, isPlaying = false) {
        const { scrollLeft: scrollLeft, scrollWidth: scrollWidth, clientWidth: clientWidth } = this.scrollContainer;
        const progressWidth = progress * scrollWidth;
        const startEdge = scrollLeft;
        const endEdge = scrollLeft + clientWidth;
        const middle = clientWidth / 2;
        if (this.isDragging) {
            // Scroll when dragging close to the edge of the viewport
            const minGap = 30;
            if (progressWidth + minGap > endEdge) this.scrollContainer.scrollLeft += minGap;
            else if (progressWidth - minGap < startEdge) this.scrollContainer.scrollLeft -= minGap;
        } else {
            if (progressWidth < startEdge || progressWidth > endEdge) this.scrollContainer.scrollLeft = progressWidth - (this.options.autoCenter ? middle : 0);
            // Keep the cursor centered when playing
            const center = progressWidth - scrollLeft - middle;
            if (isPlaying && this.options.autoCenter && center > 0) this.scrollContainer.scrollLeft += Math.min(center, 10);
        }
        // Emit the scroll event
        {
            const newScroll = this.scrollContainer.scrollLeft;
            const startX = newScroll / scrollWidth;
            const endX = (newScroll + clientWidth) / scrollWidth;
            this.emit("scroll", startX, endX);
        }
    }
    renderProgress(progress, isPlaying) {
        if (isNaN(progress)) return;
        const percents = progress * 100;
        this.canvasWrapper.style.clipPath = `polygon(${percents}% 0, 100% 0, 100% 100%, ${percents}% 100%)`;
        this.progressWrapper.style.width = `${percents}%`;
        this.cursor.style.left = `${percents}%`;
        this.cursor.style.marginLeft = Math.round(percents) === 100 ? `-${this.options.cursorWidth}px` : "";
        if (this.isScrollable && this.options.autoScroll) this.scrollIntoView(progress, isPlaying);
    }
    exportImage(format, quality, type) {
        return $9dbf784afb0c7be3$var$__awaiter(this, void 0, void 0, function*() {
            const canvases = this.canvasWrapper.querySelectorAll("canvas");
            if (!canvases.length) throw new Error("No waveform data");
            // Data URLs
            if (type === "dataURL") {
                const images = Array.from(canvases).map((canvas)=>canvas.toDataURL(format, quality));
                return Promise.resolve(images);
            }
            // Blobs
            return Promise.all(Array.from(canvases).map((canvas)=>{
                return new Promise((resolve, reject)=>{
                    canvas.toBlob((blob)=>{
                        blob ? resolve(blob) : reject(new Error("Could not export image"));
                    }, format, quality);
                });
            }));
        });
    }
}
$9dbf784afb0c7be3$var$Renderer.MAX_CANVAS_WIDTH = 4000;
var $9dbf784afb0c7be3$export$2e2bcd8739ae039 = $9dbf784afb0c7be3$var$Renderer;



class $3eb19631013a78b4$var$Timer extends (0, $41fb24c6822f7f68$export$2e2bcd8739ae039) {
    constructor(){
        super(...arguments);
        this.unsubscribe = ()=>undefined;
    }
    start() {
        this.unsubscribe = this.on("tick", ()=>{
            requestAnimationFrame(()=>{
                this.emit("tick");
            });
        });
        this.emit("tick");
    }
    stop() {
        this.unsubscribe();
    }
    destroy() {
        this.unsubscribe();
    }
}
var $3eb19631013a78b4$export$2e2bcd8739ae039 = $3eb19631013a78b4$var$Timer;



var $144984c8dc4f08bd$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * A Web Audio buffer player emulating the behavior of an HTML5 Audio element.
 */ class $144984c8dc4f08bd$var$WebAudioPlayer extends (0, $41fb24c6822f7f68$export$2e2bcd8739ae039) {
    constructor(audioContext = new AudioContext()){
        super();
        this.bufferNode = null;
        this.autoplay = false;
        this.playStartTime = 0;
        this.playedDuration = 0;
        this._muted = false;
        this.buffer = null;
        this.currentSrc = "";
        this.paused = true;
        this.crossOrigin = null;
        /** Subscribe to an event. Returns an unsubscribe function. */ this.addEventListener = this.on;
        /** Unsubscribe from an event */ this.removeEventListener = this.un;
        this.audioContext = audioContext;
        this.gainNode = this.audioContext.createGain();
        this.gainNode.connect(this.audioContext.destination);
    }
    load() {
        return $144984c8dc4f08bd$var$__awaiter(this, void 0, void 0, function*() {
            return;
        });
    }
    get src() {
        return this.currentSrc;
    }
    set src(value) {
        this.currentSrc = value;
        if (!value) {
            this.buffer = null;
            this.emit("emptied");
            return;
        }
        fetch(value).then((response)=>response.arrayBuffer()).then((arrayBuffer)=>{
            if (this.currentSrc !== value) return null;
            return this.audioContext.decodeAudioData(arrayBuffer);
        }).then((audioBuffer)=>{
            if (this.currentSrc !== value) return;
            this.buffer = audioBuffer;
            this.emit("loadedmetadata");
            this.emit("canplay");
            if (this.autoplay) this.play();
        });
    }
    _play() {
        var _a;
        if (!this.paused) return;
        this.paused = false;
        (_a = this.bufferNode) === null || _a === void 0 || _a.disconnect();
        this.bufferNode = this.audioContext.createBufferSource();
        this.bufferNode.buffer = this.buffer;
        this.bufferNode.connect(this.gainNode);
        if (this.playedDuration >= this.duration) this.playedDuration = 0;
        this.bufferNode.start(this.audioContext.currentTime, this.playedDuration);
        this.playStartTime = this.audioContext.currentTime;
        this.bufferNode.onended = ()=>{
            if (this.currentTime >= this.duration) {
                this.pause();
                this.emit("ended");
            }
        };
    }
    _pause() {
        var _a;
        if (this.paused) return;
        this.paused = true;
        (_a = this.bufferNode) === null || _a === void 0 || _a.stop();
        this.playedDuration += this.audioContext.currentTime - this.playStartTime;
    }
    play() {
        return $144984c8dc4f08bd$var$__awaiter(this, void 0, void 0, function*() {
            this._play();
            this.emit("play");
        });
    }
    pause() {
        this._pause();
        this.emit("pause");
    }
    stopAt(timeSeconds) {
        var _a, _b;
        const delay = timeSeconds - this.currentTime;
        (_a = this.bufferNode) === null || _a === void 0 || _a.stop(this.audioContext.currentTime + delay);
        (_b = this.bufferNode) === null || _b === void 0 || _b.addEventListener("ended", ()=>{
            this.bufferNode = null;
            this.pause();
        }, {
            once: true
        });
    }
    setSinkId(deviceId) {
        return $144984c8dc4f08bd$var$__awaiter(this, void 0, void 0, function*() {
            const ac = this.audioContext;
            return ac.setSinkId(deviceId);
        });
    }
    get playbackRate() {
        var _a, _b;
        return (_b = (_a = this.bufferNode) === null || _a === void 0 ? void 0 : _a.playbackRate.value) !== null && _b !== void 0 ? _b : 1;
    }
    set playbackRate(value) {
        if (this.bufferNode) this.bufferNode.playbackRate.value = value;
    }
    get currentTime() {
        return this.paused ? this.playedDuration : this.playedDuration + this.audioContext.currentTime - this.playStartTime;
    }
    set currentTime(value) {
        this.emit("seeking");
        if (this.paused) this.playedDuration = value;
        else {
            this._pause();
            this.playedDuration = value;
            this._play();
        }
        this.emit("timeupdate");
    }
    get duration() {
        var _a;
        return ((_a = this.buffer) === null || _a === void 0 ? void 0 : _a.duration) || 0;
    }
    get volume() {
        return this.gainNode.gain.value;
    }
    set volume(value) {
        this.gainNode.gain.value = value;
        this.emit("volumechange");
    }
    get muted() {
        return this._muted;
    }
    set muted(value) {
        if (this._muted === value) return;
        this._muted = value;
        if (this._muted) this.gainNode.disconnect();
        else this.gainNode.connect(this.audioContext.destination);
    }
    canPlayType(mimeType) {
        return /^(audio|video)\//.test(mimeType);
    }
    /** Get the GainNode used to play the audio. Can be used to attach filters. */ getGainNode() {
        return this.gainNode;
    }
    /** Get decoded audio */ getChannelData() {
        const channels = [];
        if (!this.buffer) return channels;
        const numChannels = this.buffer.numberOfChannels;
        for(let i = 0; i < numChannels; i++)channels.push(this.buffer.getChannelData(i));
        return channels;
    }
}
var $144984c8dc4f08bd$export$2e2bcd8739ae039 = $144984c8dc4f08bd$var$WebAudioPlayer;


var $182ce0f141db4820$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $182ce0f141db4820$var$defaultOptions = {
    waveColor: "#999",
    progressColor: "#555",
    cursorWidth: 1,
    minPxPerSec: 0,
    fillParent: true,
    interact: true,
    dragToSeek: false,
    autoScroll: true,
    autoCenter: true,
    sampleRate: 8000
};
class $182ce0f141db4820$var$WaveSurfer extends (0, $33a4d7ed38deb55a$export$2e2bcd8739ae039) {
    /** Create a new WaveSurfer instance */ static create(options) {
        return new $182ce0f141db4820$var$WaveSurfer(options);
    }
    /** Create a new WaveSurfer instance */ constructor(options){
        const media = options.media || (options.backend === "WebAudio" ? new (0, $144984c8dc4f08bd$export$2e2bcd8739ae039)() : undefined);
        super({
            media: media,
            mediaControls: options.mediaControls,
            autoplay: options.autoplay,
            playbackRate: options.audioRate
        });
        this.plugins = [];
        this.decodedData = null;
        this.subscriptions = [];
        this.mediaSubscriptions = [];
        this.options = Object.assign({}, $182ce0f141db4820$var$defaultOptions, options);
        this.timer = new (0, $3eb19631013a78b4$export$2e2bcd8739ae039)();
        const audioElement = media ? undefined : this.getMediaElement();
        this.renderer = new (0, $9dbf784afb0c7be3$export$2e2bcd8739ae039)(this.options, audioElement);
        this.initPlayerEvents();
        this.initRendererEvents();
        this.initTimerEvents();
        this.initPlugins();
        // Init and load async to allow external events to be registered
        Promise.resolve().then(()=>{
            this.emit("init");
            // Load audio if URL or an external media with an src is passed,
            // of render w/o audio if pre-decoded peaks and duration are provided
            const url = this.options.url || this.getSrc() || "";
            if (url || this.options.peaks && this.options.duration) this.load(url, this.options.peaks, this.options.duration);
        });
    }
    initTimerEvents() {
        // The timer fires every 16ms for a smooth progress animation
        this.subscriptions.push(this.timer.on("tick", ()=>{
            const currentTime = this.getCurrentTime();
            this.renderer.renderProgress(currentTime / this.getDuration(), true);
            this.emit("timeupdate", currentTime);
            this.emit("audioprocess", currentTime);
        }));
    }
    initPlayerEvents() {
        if (this.isPlaying()) {
            this.emit("play");
            this.timer.start();
        }
        this.mediaSubscriptions.push(this.onMediaEvent("timeupdate", ()=>{
            const currentTime = this.getCurrentTime();
            this.renderer.renderProgress(currentTime / this.getDuration(), this.isPlaying());
            this.emit("timeupdate", currentTime);
        }), this.onMediaEvent("play", ()=>{
            this.emit("play");
            this.timer.start();
        }), this.onMediaEvent("pause", ()=>{
            this.emit("pause");
            this.timer.stop();
        }), this.onMediaEvent("emptied", ()=>{
            this.timer.stop();
        }), this.onMediaEvent("ended", ()=>{
            this.emit("finish");
        }), this.onMediaEvent("seeking", ()=>{
            this.emit("seeking", this.getCurrentTime());
        }));
    }
    initRendererEvents() {
        this.subscriptions.push(// Seek on click
        this.renderer.on("click", (relativeX, relativeY)=>{
            if (this.options.interact) {
                this.seekTo(relativeX);
                this.emit("interaction", relativeX * this.getDuration());
                this.emit("click", relativeX, relativeY);
            }
        }), // Double click
        this.renderer.on("dblclick", (relativeX, relativeY)=>{
            this.emit("dblclick", relativeX, relativeY);
        }), // Scroll
        this.renderer.on("scroll", (startX, endX)=>{
            const duration = this.getDuration();
            this.emit("scroll", startX * duration, endX * duration);
        }), // Redraw
        this.renderer.on("render", ()=>{
            this.emit("redraw");
        }), // RedrawComplete
        this.renderer.on("rendered", ()=>{
            this.emit("redrawcomplete");
        }));
        // Drag
        {
            let debounce;
            this.subscriptions.push(this.renderer.on("drag", (relativeX)=>{
                if (!this.options.interact) return;
                // Update the visual position
                this.renderer.renderProgress(relativeX);
                // Set the audio position with a debounce
                clearTimeout(debounce);
                debounce = setTimeout(()=>{
                    this.seekTo(relativeX);
                }, this.isPlaying() ? 0 : 200);
                this.emit("interaction", relativeX * this.getDuration());
                this.emit("drag", relativeX);
            }));
        }
    }
    initPlugins() {
        var _a;
        if (!((_a = this.options.plugins) === null || _a === void 0 ? void 0 : _a.length)) return;
        this.options.plugins.forEach((plugin)=>{
            this.registerPlugin(plugin);
        });
    }
    unsubscribePlayerEvents() {
        this.mediaSubscriptions.forEach((unsubscribe)=>unsubscribe());
        this.mediaSubscriptions = [];
    }
    /** Set new wavesurfer options and re-render it */ setOptions(options) {
        this.options = Object.assign({}, this.options, options);
        this.renderer.setOptions(this.options);
        if (options.audioRate) this.setPlaybackRate(options.audioRate);
        if (options.mediaControls != null) this.getMediaElement().controls = options.mediaControls;
    }
    /** Register a wavesurfer.js plugin */ registerPlugin(plugin) {
        plugin._init(this);
        this.plugins.push(plugin);
        // Unregister plugin on destroy
        this.subscriptions.push(plugin.once("destroy", ()=>{
            this.plugins = this.plugins.filter((p)=>p !== plugin);
        }));
        return plugin;
    }
    /** For plugins only: get the waveform wrapper div */ getWrapper() {
        return this.renderer.getWrapper();
    }
    /** Get the current scroll position in pixels */ getScroll() {
        return this.renderer.getScroll();
    }
    /** Get all registered plugins */ getActivePlugins() {
        return this.plugins;
    }
    loadAudio(url, blob, channelData, duration) {
        return $182ce0f141db4820$var$__awaiter(this, void 0, void 0, function*() {
            this.emit("load", url);
            if (!this.options.media && this.isPlaying()) this.pause();
            this.decodedData = null;
            // Fetch the entire audio as a blob if pre-decoded data is not provided
            if (!blob && !channelData) {
                const onProgress = (percentage)=>this.emit("loading", percentage);
                blob = yield (0, $064d4de22181c65c$export$2e2bcd8739ae039).fetchBlob(url, onProgress, this.options.fetchParams);
            }
            // Set the mediaelement source
            this.setSrc(url, blob);
            // Wait for the audio duration
            const audioDuration = duration || this.getDuration() || (yield new Promise((resolve)=>{
                this.onceMediaEvent("loadedmetadata", ()=>resolve(this.getDuration()));
            }));
            // Decode the audio data or use user-provided peaks
            if (channelData) this.decodedData = (0, $c03aca78159de43e$export$2e2bcd8739ae039).createBuffer(channelData, audioDuration || 0);
            else if (blob) {
                const arrayBuffer = yield blob.arrayBuffer();
                this.decodedData = yield (0, $c03aca78159de43e$export$2e2bcd8739ae039).decode(arrayBuffer, this.options.sampleRate);
            }
            if (this.decodedData) {
                this.emit("decode", this.getDuration());
                this.renderer.render(this.decodedData);
            }
            this.emit("ready", this.getDuration());
        });
    }
    /** Load an audio file by URL, with optional pre-decoded audio data */ load(url, channelData, duration) {
        return $182ce0f141db4820$var$__awaiter(this, void 0, void 0, function*() {
            yield this.loadAudio(url, undefined, channelData, duration);
        });
    }
    /** Load an audio blob */ loadBlob(blob, channelData, duration) {
        return $182ce0f141db4820$var$__awaiter(this, void 0, void 0, function*() {
            yield this.loadAudio("blob", blob, channelData, duration);
        });
    }
    /** Zoom the waveform by a given pixels-per-second factor */ zoom(minPxPerSec) {
        if (!this.decodedData) throw new Error("No audio loaded");
        this.renderer.zoom(minPxPerSec);
        this.emit("zoom", minPxPerSec);
    }
    /** Get the decoded audio data */ getDecodedData() {
        return this.decodedData;
    }
    /** Get decoded peaks */ exportPeaks({ channels: channels = 2, maxLength: maxLength = 8000, precision: precision = 10000 } = {}) {
        if (!this.decodedData) throw new Error("The audio has not been decoded yet");
        const maxChannels = Math.min(channels, this.decodedData.numberOfChannels);
        const peaks = [];
        for(let i = 0; i < maxChannels; i++){
            const channel = this.decodedData.getChannelData(i);
            const data = [];
            const sampleSize = Math.round(channel.length / maxLength);
            for(let i = 0; i < maxLength; i++){
                const sample = channel.slice(i * sampleSize, (i + 1) * sampleSize);
                let max = 0;
                for(let x = 0; x < sample.length; x++){
                    const n = sample[x];
                    if (Math.abs(n) > Math.abs(max)) max = n;
                }
                data.push(Math.round(max * precision) / precision);
            }
            peaks.push(data);
        }
        return peaks;
    }
    /** Get the duration of the audio in seconds */ getDuration() {
        let duration = super.getDuration() || 0;
        // Fall back to the decoded data duration if the media duration is incorrect
        if ((duration === 0 || duration === Infinity) && this.decodedData) duration = this.decodedData.duration;
        return duration;
    }
    /** Toggle if the waveform should react to clicks */ toggleInteraction(isInteractive) {
        this.options.interact = isInteractive;
    }
    /** Seek to a percentage of audio as [0..1] (0 = beginning, 1 = end) */ seekTo(progress) {
        const time = this.getDuration() * progress;
        this.setTime(time);
    }
    /** Play or pause the audio */ playPause() {
        return $182ce0f141db4820$var$__awaiter(this, void 0, void 0, function*() {
            return this.isPlaying() ? this.pause() : this.play();
        });
    }
    /** Stop the audio and go to the beginning */ stop() {
        this.pause();
        this.setTime(0);
    }
    /** Skip N or -N seconds from the current position */ skip(seconds) {
        this.setTime(this.getCurrentTime() + seconds);
    }
    /** Empty the waveform */ empty() {
        this.load("", [
            [
                0
            ]
        ], 0.001);
    }
    /** Set HTML media element */ setMediaElement(element) {
        this.unsubscribePlayerEvents();
        super.setMediaElement(element);
        this.initPlayerEvents();
    }
    exportImage(format = "image/png", quality = 1, type = "dataURL") {
        return $182ce0f141db4820$var$__awaiter(this, void 0, void 0, function*() {
            return this.renderer.exportImage(format, quality, type);
        });
    }
    /** Unmount wavesurfer */ destroy() {
        this.emit("destroy");
        this.plugins.forEach((plugin)=>plugin.destroy());
        this.subscriptions.forEach((unsubscribe)=>unsubscribe());
        this.unsubscribePlayerEvents();
        this.timer.destroy();
        this.renderer.destroy();
        super.destroy();
    }
}
var $182ce0f141db4820$export$2e2bcd8739ae039 = $182ce0f141db4820$var$WaveSurfer;


class $1ebac55772351390$var$t {
    constructor(){
        this.listeners = {};
    }
    on(t, e, i) {
        if (this.listeners[t] || (this.listeners[t] = new Set), this.listeners[t].add(e), null == i ? void 0 : i.once) {
            const i = ()=>{
                this.un(t, i), this.un(t, e);
            };
            return this.on(t, i), i;
        }
        return ()=>this.un(t, e);
    }
    un(t, e) {
        var i;
        null === (i = this.listeners[t]) || void 0 === i || i.delete(e);
    }
    once(t, e) {
        return this.on(t, e, {
            once: !0
        });
    }
    unAll() {
        this.listeners = {};
    }
    emit(t, ...e) {
        this.listeners[t] && this.listeners[t].forEach((t)=>t(...e));
    }
}
class $1ebac55772351390$var$e extends $1ebac55772351390$var$t {
    constructor(t){
        super(), this.subscriptions = [], this.options = t;
    }
    onInit() {}
    _init(t) {
        this.wavesurfer = t, this.onInit();
    }
    destroy() {
        this.emit("destroy"), this.subscriptions.forEach((t)=>t());
    }
}
function $1ebac55772351390$var$i(t, e, i, n, s = 3, o = 0) {
    if (!t) return ()=>{};
    let r = ()=>{};
    const a = (a)=>{
        if (a.button !== o) return;
        a.preventDefault(), a.stopPropagation();
        let l = a.clientX, h = a.clientY, d = !1;
        const c = (n)=>{
            n.preventDefault(), n.stopPropagation();
            const o = n.clientX, r = n.clientY, a = o - l, c = r - h;
            if (d || Math.abs(a) > s || Math.abs(c) > s) {
                const n = t.getBoundingClientRect(), { left: s, top: u } = n;
                d || (null == i || i(l - s, h - u), d = !0), e(a, c, o - s, r - u), l = o, h = r;
            }
        }, u = ()=>{
            d && (null == n || n()), r();
        }, g = (t)=>{
            t.relatedTarget && t.relatedTarget !== document.documentElement || u();
        }, v = (t)=>{
            d && (t.stopPropagation(), t.preventDefault());
        }, p = (t)=>{
            d && t.preventDefault();
        };
        document.addEventListener("pointermove", c), document.addEventListener("pointerup", u), document.addEventListener("pointerout", g), document.addEventListener("pointercancel", g), document.addEventListener("touchmove", p, {
            passive: !1
        }), document.addEventListener("click", v, {
            capture: !0
        }), r = ()=>{
            document.removeEventListener("pointermove", c), document.removeEventListener("pointerup", u), document.removeEventListener("pointerout", g), document.removeEventListener("pointercancel", g), document.removeEventListener("touchmove", p), setTimeout(()=>{
                document.removeEventListener("click", v, {
                    capture: !0
                });
            }, 10);
        };
    };
    return t.addEventListener("pointerdown", a), ()=>{
        r(), t.removeEventListener("pointerdown", a);
    };
}
function $1ebac55772351390$var$n(t, e) {
    const i = e.xmlns ? document.createElementNS(e.xmlns, t) : document.createElement(t);
    for (const [t, s] of Object.entries(e))if ("children" === t) for (const [t, s] of Object.entries(e))"string" == typeof s ? i.appendChild(document.createTextNode(s)) : i.appendChild($1ebac55772351390$var$n(t, s));
    else "style" === t ? Object.assign(i.style, s) : "textContent" === t ? i.textContent = s : i.setAttribute(t, s.toString());
    return i;
}
function $1ebac55772351390$var$s(t, e, i) {
    const s = $1ebac55772351390$var$n(t, e || {});
    return null == i || i.appendChild(s), s;
}
class $1ebac55772351390$var$o extends $1ebac55772351390$var$t {
    constructor(t, e, i = 0){
        var n, s, o, r, a, l, h, d;
        super(), this.totalDuration = e, this.numberOfChannels = i, this.minLength = 0, this.maxLength = 1 / 0, this.contentEditable = !1, this.id = t.id || `region-${Math.random().toString(32).slice(2)}`, this.start = this.clampPosition(t.start), this.end = this.clampPosition(null !== (n = t.end) && void 0 !== n ? n : t.start), this.drag = null === (s = t.drag) || void 0 === s || s, this.resize = null === (o = t.resize) || void 0 === o || o, this.color = null !== (r = t.color) && void 0 !== r ? r : "rgba(0, 0, 0, 0.1)", this.minLength = null !== (a = t.minLength) && void 0 !== a ? a : this.minLength, this.maxLength = null !== (l = t.maxLength) && void 0 !== l ? l : this.maxLength, this.channelIdx = null !== (h = t.channelIdx) && void 0 !== h ? h : -1, this.contentEditable = null !== (d = t.contentEditable) && void 0 !== d ? d : this.contentEditable, this.element = this.initElement(), this.setContent(t.content), this.setPart(), this.renderPosition(), this.initMouseEvents();
    }
    clampPosition(t) {
        return Math.max(0, Math.min(this.totalDuration, t));
    }
    setPart() {
        const t = this.start === this.end;
        this.element.setAttribute("part", `${t ? "marker" : "region"} ${this.id}`);
    }
    addResizeHandles(t) {
        const e = {
            position: "absolute",
            zIndex: "2",
            width: "6px",
            height: "100%",
            top: "0",
            cursor: "ew-resize",
            wordBreak: "keep-all"
        }, n = $1ebac55772351390$var$s("div", {
            part: "region-handle region-handle-left",
            style: Object.assign(Object.assign({}, e), {
                left: "0",
                borderLeft: "2px solid rgba(0, 0, 0, 0.5)",
                borderRadius: "2px 0 0 2px"
            })
        }, t), o = $1ebac55772351390$var$s("div", {
            part: "region-handle region-handle-right",
            style: Object.assign(Object.assign({}, e), {
                right: "0",
                borderRight: "2px solid rgba(0, 0, 0, 0.5)",
                borderRadius: "0 2px 2px 0"
            })
        }, t);
        $1ebac55772351390$var$i(n, (t)=>this.onResize(t, "start"), ()=>null, ()=>this.onEndResizing(), 1), $1ebac55772351390$var$i(o, (t)=>this.onResize(t, "end"), ()=>null, ()=>this.onEndResizing(), 1);
    }
    removeResizeHandles(t) {
        const e = t.querySelector('[part*="region-handle-left"]'), i = t.querySelector('[part*="region-handle-right"]');
        e && t.removeChild(e), i && t.removeChild(i);
    }
    initElement() {
        const t = this.start === this.end;
        let e = 0, i = 100;
        this.channelIdx >= 0 && this.channelIdx < this.numberOfChannels && (i = 100 / this.numberOfChannels, e = i * this.channelIdx);
        const n = $1ebac55772351390$var$s("div", {
            style: {
                position: "absolute",
                top: `${e}%`,
                height: `${i}%`,
                backgroundColor: t ? "none" : this.color,
                borderLeft: t ? "2px solid " + this.color : "none",
                borderRadius: "2px",
                boxSizing: "border-box",
                transition: "background-color 0.2s ease",
                cursor: this.drag ? "grab" : "default",
                pointerEvents: "all"
            }
        });
        return !t && this.resize && this.addResizeHandles(n), n;
    }
    renderPosition() {
        const t = this.start / this.totalDuration, e = (this.totalDuration - this.end) / this.totalDuration;
        this.element.style.left = 100 * t + "%", this.element.style.right = 100 * e + "%";
    }
    toggleCursor(t) {
        this.drag && (this.element.style.cursor = t ? "grabbing" : "grab");
    }
    initMouseEvents() {
        const { element: t } = this;
        t && (t.addEventListener("click", (t)=>this.emit("click", t)), t.addEventListener("mouseenter", (t)=>this.emit("over", t)), t.addEventListener("mouseleave", (t)=>this.emit("leave", t)), t.addEventListener("dblclick", (t)=>this.emit("dblclick", t)), t.addEventListener("pointerdown", ()=>this.toggleCursor(!0)), t.addEventListener("pointerup", ()=>this.toggleCursor(!1)), $1ebac55772351390$var$i(t, (t)=>this.onMove(t), ()=>this.toggleCursor(!0), ()=>{
            this.toggleCursor(!1), this.drag && this.emit("update-end");
        }), this.contentEditable && this.content && (this.content.addEventListener("click", (t)=>this.onContentClick(t)), this.content.addEventListener("blur", ()=>this.onContentBlur())));
    }
    _onUpdate(t, e) {
        if (!this.element.parentElement) return;
        const { width: i } = this.element.parentElement.getBoundingClientRect(), n = t / i * this.totalDuration, s = e && "start" !== e ? this.start : this.start + n, o = e && "end" !== e ? this.end : this.end + n, r = o - s;
        s >= 0 && o <= this.totalDuration && s <= o && r >= this.minLength && r <= this.maxLength && (this.start = s, this.end = o, this.renderPosition(), this.emit("update"));
    }
    onMove(t) {
        this.drag && this._onUpdate(t);
    }
    onResize(t, e) {
        this.resize && this._onUpdate(t, e);
    }
    onEndResizing() {
        this.resize && this.emit("update-end");
    }
    onContentClick(t) {
        t.stopPropagation();
        t.target.focus(), this.emit("click", t);
    }
    onContentBlur() {
        this.emit("update-end");
    }
    _setTotalDuration(t) {
        this.totalDuration = t, this.renderPosition();
    }
    play() {
        this.emit("play");
    }
    setContent(t) {
        var e;
        if (null === (e = this.content) || void 0 === e || e.remove(), t) {
            if ("string" == typeof t) {
                const e = this.start === this.end;
                this.content = $1ebac55772351390$var$s("div", {
                    style: {
                        padding: `0.2em ${e ? .2 : .4}em`,
                        display: "inline-block"
                    },
                    textContent: t
                });
            } else this.content = t;
            this.contentEditable && (this.content.contentEditable = "true"), this.content.setAttribute("part", "region-content"), this.element.appendChild(this.content);
        } else this.content = void 0;
    }
    setOptions(t) {
        var e, i;
        if (t.color && (this.color = t.color, this.element.style.backgroundColor = this.color), void 0 !== t.drag && (this.drag = t.drag, this.element.style.cursor = this.drag ? "grab" : "default"), void 0 !== t.start || void 0 !== t.end) {
            const n = this.start === this.end;
            this.start = this.clampPosition(null !== (e = t.start) && void 0 !== e ? e : this.start), this.end = this.clampPosition(null !== (i = t.end) && void 0 !== i ? i : n ? this.start : this.end), this.renderPosition(), this.setPart();
        }
        if (t.content && this.setContent(t.content), t.id && (this.id = t.id, this.setPart()), void 0 !== t.resize && t.resize !== this.resize) {
            const e = this.start === this.end;
            this.resize = t.resize, this.resize && !e ? this.addResizeHandles(this.element) : this.removeResizeHandles(this.element);
        }
    }
    remove() {
        this.emit("remove"), this.element.remove(), this.element = null;
    }
}
class $1ebac55772351390$export$2e2bcd8739ae039 extends $1ebac55772351390$var$e {
    constructor(t){
        super(t), this.regions = [], this.regionsContainer = this.initRegionsContainer();
    }
    static create(t) {
        return new $1ebac55772351390$export$2e2bcd8739ae039(t);
    }
    onInit() {
        if (!this.wavesurfer) throw Error("WaveSurfer is not initialized");
        this.wavesurfer.getWrapper().appendChild(this.regionsContainer);
        let t = [];
        this.subscriptions.push(this.wavesurfer.on("timeupdate", (e)=>{
            const i = this.regions.filter((t)=>t.start <= e && (t.end === t.start ? t.start + .05 : t.end) >= e);
            i.forEach((e)=>{
                t.includes(e) || this.emit("region-in", e);
            }), t.forEach((t)=>{
                i.includes(t) || this.emit("region-out", t);
            }), t = i;
        }));
    }
    initRegionsContainer() {
        return $1ebac55772351390$var$s("div", {
            style: {
                position: "absolute",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
                zIndex: "3",
                pointerEvents: "none"
            }
        });
    }
    getRegions() {
        return this.regions;
    }
    avoidOverlapping(t) {
        if (!t.content) return;
        const e = t.content, i = e.getBoundingClientRect(), n = this.regions.map((e)=>{
            if (e === t || !e.content) return 0;
            const n = e.content.getBoundingClientRect();
            return i.left < n.left + n.width && n.left < i.left + i.width ? n.height : 0;
        }).reduce((t, e)=>t + e, 0);
        e.style.marginTop = `${n}px`;
    }
    adjustScroll(t) {
        var e, i;
        const n = null === (i = null === (e = this.wavesurfer) || void 0 === e ? void 0 : e.getWrapper()) || void 0 === i ? void 0 : i.parentElement;
        if (!n) return;
        const { clientWidth: s, scrollWidth: o } = n;
        if (o <= s) return;
        const r = n.getBoundingClientRect(), a = t.element.getBoundingClientRect(), l = a.left - r.left, h = a.right - r.left;
        l < 0 ? n.scrollLeft += l : h > s && (n.scrollLeft += h - s);
    }
    saveRegion(t) {
        this.regionsContainer.appendChild(t.element), this.avoidOverlapping(t), this.regions.push(t);
        const e = [
            t.on("update", ()=>{
                this.adjustScroll(t);
            }),
            t.on("update-end", ()=>{
                this.avoidOverlapping(t), this.emit("region-updated", t);
            }),
            t.on("play", ()=>{
                var e, i;
                null === (e = this.wavesurfer) || void 0 === e || e.play(), null === (i = this.wavesurfer) || void 0 === i || i.setTime(t.start);
            }),
            t.on("click", (e)=>{
                this.emit("region-clicked", t, e);
            }),
            t.on("dblclick", (e)=>{
                this.emit("region-double-clicked", t, e);
            }),
            t.once("remove", ()=>{
                e.forEach((t)=>t()), this.regions = this.regions.filter((e)=>e !== t), this.emit("region-removed", t);
            })
        ];
        this.subscriptions.push(...e), this.emit("region-created", t);
    }
    addRegion(t) {
        var e, i;
        if (!this.wavesurfer) throw Error("WaveSurfer is not initialized");
        const n = this.wavesurfer.getDuration(), s = null === (i = null === (e = this.wavesurfer) || void 0 === e ? void 0 : e.getDecodedData()) || void 0 === i ? void 0 : i.numberOfChannels, r = new $1ebac55772351390$var$o(t, n, s);
        return n ? this.saveRegion(r) : this.subscriptions.push(this.wavesurfer.once("ready", (t)=>{
            r._setTotalDuration(t), this.saveRegion(r);
        })), r;
    }
    enableDragSelection(t, e = 3) {
        var n;
        const s = null === (n = this.wavesurfer) || void 0 === n ? void 0 : n.getWrapper();
        if (!(s && s instanceof HTMLElement)) return ()=>{};
        let r = null, a = 0;
        return $1ebac55772351390$var$i(s, (t, e, i)=>{
            r && r._onUpdate(t, i > a ? "end" : "start");
        }, (e)=>{
            var i, n;
            if (a = e, !this.wavesurfer) return;
            const s = this.wavesurfer.getDuration(), l = null === (n = null === (i = this.wavesurfer) || void 0 === i ? void 0 : i.getDecodedData()) || void 0 === n ? void 0 : n.numberOfChannels, { width: h } = this.wavesurfer.getWrapper().getBoundingClientRect(), d = e / h * s, c = (e + 5) / h * s;
            r = new $1ebac55772351390$var$o(Object.assign(Object.assign({}, t), {
                start: d,
                end: c
            }), s, l), this.regionsContainer.appendChild(r.element);
        }, ()=>{
            r && (this.saveRegion(r), r = null);
        }, e);
    }
    clearRegions() {
        this.regions.forEach((t)=>t.remove());
    }
    destroy() {
        this.clearRegions(), super.destroy(), this.regionsContainer.remove();
    }
}


// XXX: Hack to allow interaction and listen to region-out
let $35da740d59af89ba$var$disableRegionOut = false;
let $35da740d59af89ba$var$disableRegionOutPauseMillis = 0;
const $35da740d59af89ba$var$setDisableRegionOutTrue = ()=>{
    $35da740d59af89ba$var$disableRegionOut = true;
    setTimeout(()=>{
        $35da740d59af89ba$var$disableRegionOut = false;
        $35da740d59af89ba$var$disableRegionOutPauseMillis = 0;
    }, 100 + $35da740d59af89ba$var$disableRegionOutPauseMillis);
};
let $35da740d59af89ba$var$paused = false;
const $35da740d59af89ba$var$initWavesurfer = async (fileName, blob)=>{
    try {
        await $35da740d59af89ba$var$initWavesurferInternal(fileName, blob);
        return true;
    } catch (err) {
        console.log(`Error loading file: ${err}`);
    }
    return false;
};
const $35da740d59af89ba$var$initWavesurferInternal = async (fileName, blob)=>{
    let activeRegion = null;
    const ws = (0, $182ce0f141db4820$export$2e2bcd8739ae039).create({
        container: "#waveform",
        loop: true,
        mediaControls: true
    });
    await ws.load(blob);
    ws.on("interaction", (e)=>{
        activeRegion = null;
        console.log("interaction");
        $35da740d59af89ba$var$paused = false;
        $35da740d59af89ba$var$setDisableRegionOutTrue();
    });
    const wsRegions = ws.registerPlugin((0, $1ebac55772351390$export$2e2bcd8739ae039).create({
        container: "#waveform",
        loop: true
    }));
    wsRegions.enableDragSelection({
        color: "rgba(255, 0, 0, 0.1)",
        loop: true
    });
    wsRegions.on("region-clicked", (region, e)=>{
        e.stopPropagation();
        const start = region.start / ws.getDuration();
        region.loop = true;
        $35da740d59af89ba$var$setDisableRegionOutTrue();
        region.play();
        $35da740d59af89ba$var$paused = false;
    });
    wsRegions.on("region-in", async (region)=>{
        activeRegion = region;
        $(".list-group-item").removeClass("active");
        $(`#li-${region.id}`).addClass("active");
    });
    wsRegions.on("region-out", async (region)=>{
        if ($35da740d59af89ba$var$disableRegionOut) {
            $35da740d59af89ba$var$disableRegionOut = false;
            return;
        }
        if ($35da740d59af89ba$var$paused) return;
        $35da740d59af89ba$var$paused = true;
        if (Math.abs(region.end - ws.getCurrentTime()) > 0.1) return;
        $(`#li-${region.id}`).removeClass("active");
        const start = region.start / ws.getDuration();
        ws.pause();
        ws.seekTo(start);
        region.loop = true;
        let pause = 0;
        try {
            pause = parseInt($("#pause-secs").val());
        } catch (ignore) {}
        const pauseMillis = pause * 1000;
        $35da740d59af89ba$var$disableRegionOutPauseMillis = pauseMillis;
        let timerInterval;
        if (pause) {
            let timeLeftMillis = pauseMillis;
            console.log("pausing for " + pause + " seconds");
            $("#timer").text(timeLeftMillis + "ms");
            $("#timer").css("width", "0%");
            $("#timer-wrapper").show();
            $35da740d59af89ba$var$paused = true;
            timerInterval = setInterval(()=>{
                if (!$35da740d59af89ba$var$paused) {
                    console.log("interrupted");
                    // Let this be interruptable.
                    // This fucking sucks.
                    if (timerInterval) clearInterval(timerInterval);
                    timerInterval = null;
                    $("#timer-wrapper").hide();
                    return;
                }
                timeLeftMillis -= 100;
                const perc = (pauseMillis - timeLeftMillis) / pauseMillis * 100;
                $("#timer").css("width", perc + "%");
                $("#timer").text(timeLeftMillis + "ms");
                if (timeLeftMillis <= 0) {
                    $("#timer-wrapper").hide();
                    region.play();
                    $35da740d59af89ba$var$paused = false;
                    if (timerInterval) clearInterval(timerInterval);
                }
            }, 100);
        } else {
            region.play();
            $35da740d59af89ba$var$paused = false;
        }
    });
    const localStorageKey = `regions-${fileName}`;
    const saveRegions = ()=>localStorage.setItem(localStorageKey, JSON.stringify(wsRegions.regions));
    const clearRegions = ()=>{
        localStorage.removeItem(localStorageKey);
        $("#restore-btn").hide();
        $("#clear-btn").hide();
    };
    const clearAllRegions = ()=>{
        Object.keys(localStorage).filter((key)=>key.startsWith("regions-")).forEach((key)=>localStorage.removeItem(key));
        $("#restore-btn").hide();
        $("#clear-btn").hide();
        $("#clear-all-btn").hide();
    };
    const restoreRegions = ()=>JSON.parse(localStorage.getItem(localStorageKey)).forEach((region)=>wsRegions.addRegion(region));
    let regionNum = 1;
    const addContentToList = (region, strContent, el)=>{
        $(el).html(`<b>${strContent}</b> - ${region.start.toFixed(2)}s to ${region.end.toFixed(2)}s`);
    };
    wsRegions.on("region-updated", (region)=>{
        region.loop = true;
        saveRegions();
        addContentToList(region, region.strContent, $(`#li-${region.id}`));
    });
    wsRegions.on("region-created", (region)=>{
        const strContent = String(regionNum++);
        const content = $("<span>").text(strContent);
        region.strContent = strContent;
        // region.content = content;
        saveRegions();
        const el = $("<a>").attr("href", "#").addClass("list-group-item").addClass("list-group-item-action").attr("id", `li-${region.id}`);
        addContentToList(region, strContent, el);
        $("#regions-list").append(el);
        el.click((e)=>{
            e.preventDefault();
            e.stopPropagation();
            region.play();
            $35da740d59af89ba$var$paused = false;
        });
    });
    wsRegions.on("region-created", saveRegions);
    wsRegions.on("region-removed", saveRegions);
    if (localStorage.getItem(localStorageKey)) {
        $("#restore-btn").show();
        $("#restore-btn").click(restoreRegions);
        $("#clear-btn").show();
        $("#clear-btn").click(clearRegions);
    } else {
        $("#restore-btn").hide();
        $("#clear-btn").hide();
    }
    const hasAnySavdRegions = Object.keys(localStorage).some((key)=>key.startsWith("regions-"));
    if (hasAnySavdRegions) {
        $("#clear-all-btn").show();
        $("#clear-all-btn").click(clearAllRegions);
    } else $("#clear-all-btn").hide();
};
const $35da740d59af89ba$var$main = async ()=>{
    const params = new URLSearchParams(document.location.search);
    const file = params.get("load");
    if (file) {
        if (await $35da740d59af89ba$var$initWavesurfer(file, file)) {
            $(".before-play").hide();
            $(".playing").show();
            return;
        }
        $("#waveform").empty();
        alert(`problem auto loading ${file}`);
        return;
    }
    $(".before-play").show();
    $("#upload").change(()=>{
        const file = document.getElementById("upload").files[0];
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = async (e)=>{
            const blob = fileReader.result;
            if (await $35da740d59af89ba$var$initWavesurfer(file.name, blob)) {
                $(".before-play").hide();
                $(".playing").show();
                return;
            }
            $("#waveform").empty();
            alert(`problem loading ${file}`);
        };
    });
};
$35da740d59af89ba$var$main();


//# sourceMappingURL=index.14b52273.js.map
